import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { DocumentsDetailModule } from './../components/documentsDetail.module';
import { TranslateModule } from '@ngx-translate/core';
import { RejectionPanelComponent } from './rejectionPanel.component';

@NgModule({
    declarations: [RejectionPanelComponent],
    imports: [
        TranslateModule,
        CommonModule,
        FormsModule,
        DocumentsDetailModule
    ],
    exports: [RejectionPanelComponent]
})

export class RejectionPanelModule { }
